import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MobileGuard from './components/MobileGuard';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MobileGuard>
      <App />
    </MobileGuard>
  </React.StrictMode>
);
